import type { Theme } from '../lib/theme.js';
import { useTheme } from '../lib/theme.js';

/**
 * Settings control for appearance (light / dark). Reuses the
 * radio-option styling from the home-layout chooser. The choice is
 * per-device (see lib/theme.tsx), so it applies immediately and
 * persists in localStorage — no API round-trip.
 */

const OPTIONS: { value: Theme; title: string; desc: string }[] = [
  { value: 'system', title: 'System', desc: 'Match your device.' },
  { value: 'light', title: 'Light', desc: 'Warm paper.' },
  { value: 'dark', title: 'Dark', desc: 'Warm lamplight for the evening.' },
];

export function ThemeSection() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="home-layout">
      <span className="reminder-toggle__heading">Appearance</span>
      <div className="home-layout-options" role="radiogroup" aria-label="Appearance">
        {OPTIONS.map((o) => {
          const selected = theme === o.value;
          return (
            <button
              key={o.value}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`home-layout-option${selected ? ' home-layout-option--selected' : ''}`}
              onClick={() => setTheme(o.value)}
            >
              <span className="home-layout-option__radio" aria-hidden="true" />
              <span className="home-layout-option__text">
                <span className="home-layout-option__title">{o.title}</span>
                <span className="home-layout-option__desc">{o.desc}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
